module.exports = __webpack_public_path__ + "static/images/item-list.02a48825be3e142a465131a0e32f3efa.svg";